import { handleActions } from 'redux-actions';
import action from '../action';
import { produce } from 'immer';

const { actionTypes } = action;
const { systemSettings } = actionTypes;

const defaultState = {
  navigatorData: {},
  valuedriverData: {},
  guidingPrincipleData: [],
  fetchingValueDriverTmplt: false,
};

const getState = (key) => (state, action) =>
  produce(state, (draft) => {
    if (Array.isArray(draft[key])) {
      draft[key] = action.payload;
    } else {
      draft[key] = { ...draft[key], ...action.payload };
    }
  });

export default handleActions(
  {
    [systemSettings.CHANGE_NAVIGATION]: getState('navigatorData'),

    [systemSettings.CHANGE_VALUE_DRIVER]: getState('valuedriverData'),

    [systemSettings.CHANGE_GUIDING_PRINCIPLE]: getState('guidingPrincipleData'),

    [systemSettings.CHANGE_WHITE_LIST]: getState('whiteList'),

    [systemSettings.REMOVE_WHITE_LIST_USER]: (state, { payload: guid }) => {
      if (typeof guid !== 'string') {
        return state;
      }
      return produce(state, (draft) => {
        if (Array.isArray(draft.whiteList?.listData)) {
          draft.whiteList.listData = draft.whiteList.listData.filter(
            (i) => i.guid !== guid,
          );
        }
      });
    },
    [systemSettings.CHANGE_WHITE_LIST_USER]: (state, { payload }) => {
      const { user } = payload;
      if (!user?.guid) {
        return state;
      }
      return produce(state, (draft) => {
        if (Array.isArray(draft.whiteList?.listData)) {
          const index = draft.whiteList.listData.findIndex(
            (i) => i.guid === user.guid,
          );
          draft.whiteList.listData[index] = user;
          draft.whiteList.listData = [...draft.whiteList.listData];
        }
      });
    },
    [systemSettings.CHANGE_FETCHING_VALUE_DRIVER_TMPLT]: (state, action) =>
      produce(state, (draft) => {
        draft.fetchingValueDriverTmplt = action.payload;
      }),
  },
  defaultState,
);
